import { Navigate } from "react-router-dom";
import { useApplication } from "../contexts/ApplicationContext";
import {
  SkeletonHeader,
  SkeletonKpiStrip,
  SkeletonTable,
} from "../components/crm/Skeletons";

/**
 * Barra telas exclusivas de administrador quando alguém digita a URL direto.
 *
 * O redirecionamento só acontece depois que o usuário carrega — antes disso o
 * papel ainda é o restrito por padrão e mandaria o admin embora sem motivo.
 *
 * Enquanto espera, mostra um ESQUELETO de página e não um spinner. A diferença
 * aparece em toda rota de administrador (Métricas, Usuários, Pagamentos,
 * Comunicados, Acessos): a tela por baixo nunca chegava a renderizar o
 * esqueleto dela, porque esta guarda devolvia o spinner antes — e o resultado
 * era que justamente as telas mais pesadas eram as únicas sem esqueleto.
 *
 * A forma é genérica de propósito (cabeçalho + indicadores + tabela): daqui
 * não dá para saber qual tela vem, e essa é a estrutura que a maioria delas
 * tem. Assim que o papel resolve, a tela assume com o esqueleto próprio.
 */
const RequireAdmin = ({ children }) => {
  const { isAdmin, isLoadingUser } = useApplication();

  if (isLoadingUser) {
    return (
      <div className="space-y-4">
        <SkeletonHeader />
        <SkeletonKpiStrip count={4} />
        <SkeletonTable rows={6} cols={5} />
      </div>
    );
  }

  if (!isAdmin) return <Navigate to="/clientes" replace />;

  return children;
};

export default RequireAdmin;
